import React, { useState } from "react";
import { useTheme } from "../context/ThemeContext";
import { useGlobal } from "../global/user";
import { MdPalette } from "react-icons/md";
import "../css/button.css";

export default function ThemeSwitcher() {
  const { currentTheme, changeTheme, availableThemes, isThemeLocked } = useTheme();
  const { user } = useGlobal();
  const [isOpen, setIsOpen] = useState(false);

  // 檢查用戶是否有權限切換主題
  const hasThemePermission = user && user.class && user.class >= process.env.REACT_APP_MANAGER_CALSS_LV;

  const handleThemeChange = (themeName) => {
    changeTheme(themeName);
    setIsOpen(false);
  };

  // 沒有權限，或主題已由公司品牌鎖定時，完全隱藏主題切換器
  if (!hasThemePermission || isThemeLocked) {
    return null;
  }

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="theme-switcher-button"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "8px 16px",
          cursor: "pointer",
          background: "var(--button-background)",
          color: "var(--button-text)",
          border: "2px solid var(--button-border)",
          borderRadius: "6px",
          fontWeight: 500,
          fontSize: "14px",
          transition: "all 0.3s ease",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
        onMouseEnter={(e) => {
          // 用 currentTarget：滑鼠移到內部 icon 時才不會把樣式套到 svg 上
          e.currentTarget.style.borderColor = "var(--button-hover-border)";
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = "var(--button-border)";
          e.currentTarget.style.transform = "none";
          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
        }}
        title="切換主題"
      >
        <MdPalette size={20} />
        主題
      </button>

      {isOpen && (
        <div
          className="theme-switcher-dropdown"
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            marginTop: "8px",
            background: "var(--modal-background)",
            border: "1px solid var(--border-color)",
            borderRadius: "4px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            minWidth: "150px",
            maxHeight: "320px",
            overflowY: "auto",
            zIndex: 1000,
          }}
        >
          {availableThemes.map((theme) => (
            <div
              key={theme.name}
              onClick={() => handleThemeChange(theme.name)}
              style={{
                padding: "10px 16px",
                cursor: "pointer",
                borderBottom:
                  theme.name === availableThemes[availableThemes.length - 1].name
                    ? "none"
                    : "1px solid var(--border-color)",
                backgroundColor:
                  currentTheme === theme.name
                    ? "var(--table-row-odd-background)"
                    : "transparent",
                color: "var(--primary-text)",
                fontWeight: currentTheme === theme.name ? "bold" : "normal",
                transition: "background-color 0.2s ease",
              }}
              onMouseEnter={(e) => {
                if (currentTheme !== theme.name) {
                  e.currentTarget.style.backgroundColor = "var(--table-row-odd-background)";
                }
              }}
              onMouseLeave={(e) => {
                if (currentTheme !== theme.name) {
                  e.currentTarget.style.backgroundColor = "transparent";
                }
              }}
            >
              {theme.displayName}
              {currentTheme === theme.name && " ✓"}
            </div>
          ))}
        </div>
      )}

      {/* 點擊外部時關閉選單 */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
          }}
        />
      )}
    </div>
  );
}